import { useEffect, useState } from "react";
import Shell from "../components/Shell";
import api from "../lib/api";

export default function Contact() {
    const [info, setInfo] = useState(null);
    useEffect(() => {
        api.get("/public/contact").then(r => setInfo(r.data)).catch(() => {});
    }, []);

    return (
        <Shell variant="public">
            <div className="max-w-4xl mx-auto px-6 py-20 animate-fade-in">
                <p className="eyebrow mb-3">Contact</p>
                <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tight mb-3">Get in touch</h1>
                <p className="text-zinc-600 max-w-xl mb-16">For clinic enquiries, training, brand partnerships and existing-account support.</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="card-base p-8">
                        <p className="eyebrow mb-2">Email</p>
                        <a href={`mailto:${info?.email || "info@dermalis.co.nz"}`} data-testid="contact-email" className="font-heading text-xl text-black hover:underline">{info?.email || "info@dermalis.co.nz"}</a>
                    </div>
                    <div className="card-base p-8">
                        <p className="eyebrow mb-2">Phone</p>
                        <p data-testid="contact-phone" className="font-heading text-xl text-black">{info?.phone || "+64 9 000 0000"}</p>
                    </div>
                    <div className="card-base p-8 md:col-span-2">
                        <p className="eyebrow mb-2">Address</p>
                        <p data-testid="contact-address" className="text-zinc-700">{info?.address || "Auckland, New Zealand"}</p>
                    </div>
                </div>
            </div>
        </Shell>
    );
}
